<nav class="px-6 py-6">
    <ol class="flex items-start max-w-4xl mx-auto m-0 p-0 list-none">
        @for (step of steps(); track step.id; let i = $index) {
            @let active = step.id === currentId();
            @let completed = i < currentIndex();
            @let reachable = isReachable(step.id);
            <li class="flex items-start gap-0 flex-1 last:flex-none">
                <div class="flex flex-col items-center flex-none">
                    <!-- Exception to the u2b corner-radius rule: step indicators -->
                    <!-- are iconic circular nodes — see README §6a. -->
                    <div class="relative">
                        <p-button
                            [rounded]="true"
                            [severity]="active || completed ? null : 'secondary'"
                            [disabled]="!reachable"
                            [styleClass]="
                                '!w-11 !h-11 !p-0 !justify-center transition-transform' +
                                (active ? ' !scale-110 shadow-lg' : '') +
                                (completed && !active ? ' u2b-wizard-stepper__circle--completed' : '')"
                            (onClick)="onStepClick(step.id)"
                            [attr.aria-current]="active ? 'step' : null"
                            [attr.aria-label]="(step.labelKey | translate)">
                            <span pButtonIcon class="material-icons" style="font-size: 1.125rem;">{{ step.icon }}</span>
                        </p-button>
                        @if (isInvalid(step.id)) {
                            <span
                                class="material-icons absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-red-600 text-white flex items-center justify-center ring-2 ring-p-surface-50"
                                style="font-size: 0.7rem; line-height: 1;"
                                aria-hidden="true">priority_high</span>
                        }
                    </div>
                    <span
                        [ngClass]="isInvalid(step.id) ? 'text-red-600 font-semibold' : (active ? 'text-p-primary font-semibold' : 'text-p-text-muted')"
                        class="text-xs mt-1.5 text-center max-w-[72px] leading-tight break-words hyphens-auto">
                        {{ step.labelKey | translate }}
                    </span>
                </div>
                @if (i < steps().length - 1) {
                    <div
                        aria-hidden="true"
                        [ngClass]="completed ? 'bg-teal-700' : 'bg-p-surface-200'"
                        class="flex-1 h-0.5 mx-1.5 mt-[21px] transition-colors"></div>
                }
            </li>
        }
    </ol>
</nav>
